import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/ecomTool',
  component: layout,
  meta: {
    funcID: 'E0012',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'amzCtnPdf',
      name: `${pre}amzCtnPdf`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001201',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/ecomTool/amzCtnPdf'),
    },
  ])('ecom-ecomTool-'),
}
